import { IconTokens, } from "@voltmoney/schema";
import { AssetRepositoryType, } from "../../../configs/config";
import SharedPropsService from "../../../SharedPropsService";
import { ROUTE } from "../../../routes";
let selectedAssetRepository;
export const goBack = async (action, _datastore, { goBack }) => {
    goBack();
};
export const toggleRadio = async (action, _datastore, { setDatastore }) => {
    if (action.payload.value === AssetRepositoryType.KARVY) {
        await setDatastore(action.routeId, "kfinRadio", {
            name: IconTokens.RadioCircleFilled,
        });
        await setDatastore(action.routeId, "camsRadio", {
            name: IconTokens.RadioCircleNotFilled,
        });
        await setDatastore(action.routeId, 'mfCentralRadio', {
            name: IconTokens.RadioCircleNotFilled,
        });
        selectedAssetRepository = AssetRepositoryType.KARVY;
    }
    else if (action.payload.value === AssetRepositoryType.MFCENTRAL) {
        await setDatastore(action.routeId, 'kfinRadio', {
            name: IconTokens.RadioCircleNotFilled,
        });
        await setDatastore(action.routeId, 'camsRadio', {
            name: IconTokens.RadioCircleNotFilled,
        });
        await setDatastore(action.routeId, 'mfCentralRadio', {
            name: IconTokens.RadioCircleFilled,
        });
        selectedAssetRepository = AssetRepositoryType.MFCENTRAL;
    }
    else {
        await setDatastore(action.routeId, "kfinRadio", {
            name: IconTokens.RadioCircleNotFilled,
        });
        await setDatastore(action.routeId, "camsRadio", {
            name: IconTokens.RadioCircleFilled,
        });
        await setDatastore(action.routeId, 'mfCentralRadio', {
            name: IconTokens.RadioCircleNotFilled,
        });
        selectedAssetRepository = AssetRepositoryType.CAMS;
    }
};
export const confirmCTA = async (action, _datastore, { instrumentTrack, navigate, setDatastore, navigateToBase }) => {
    instrumentTrack("SOURCE_RTA_CLICKED", {
        RTA: selectedAssetRepository
    });
    const assetRepository = action?.payload?.assetRepository;
    instrumentTrack("GET_PORTFOLIO_SOURCE_UPDATED", { "updated_source": selectedAssetRepository });
    await SharedPropsService.setRtaModalBGColor('rgba(0, 0, 0, 0.50)');
    await navigateToBase(ROUTE.MF_FETCH_PORTFOLIO, { assetRepository: selectedAssetRepository !== undefined ? selectedAssetRepository : assetRepository });
};
